import { LineOfBusinessEnum } from 'src/app/compliance/api/enums/line-of-business-enum.enum';

export enum LineOfBusiness {
    All = 0,
    PerDiem = 1,
    Travel = 2,
    Locums = 3,
    NonClinical = 4,
    LocalLongTerm = 5,
    Permanent = 6,
    WorkforceDisruptionClinical = 7,
    WorkforceDisruptionNonClinical = 8,
    AccessControl = 9,
    InterimLeadership = 10,
    PayrollServices = 11
}

export function MappedLineOfBusiness(lob: LineOfBusiness): LineOfBusiness {
    switch (lob) {
        case LineOfBusiness.AccessControl:
            return LineOfBusiness.AccessControl;
        case LineOfBusiness.Locums:
            return LineOfBusiness.Locums;
        default:
            return LineOfBusiness.Travel;
    }
}

export function nameOf(value: LineOfBusiness): string {
    switch (value) {
        case LineOfBusiness.PerDiem:
            return 'Per Diem';
        case LineOfBusiness.Travel:
            return 'Travel';
        case LineOfBusiness.Locums:
            return 'Locums';
        case LineOfBusiness.NonClinical:
            return 'Non Clinical';
        case LineOfBusiness.LocalLongTerm:
            return 'Local Long Term';
        case LineOfBusiness.AccessControl:
            return 'Access Control';
        case LineOfBusiness.All:
            return 'All';
    }
}

export function mapLineOfBusinessToEnum(lob: LineOfBusiness): LineOfBusinessEnum | null {
    switch (lob) {
        case LineOfBusiness.PerDiem:
            return LineOfBusinessEnum.PerDiem;
        case LineOfBusiness.Travel:
            return LineOfBusinessEnum.Travel;
        case LineOfBusiness.Locums:
            return LineOfBusinessEnum.Locums;
        case LineOfBusiness.NonClinical:
            return LineOfBusinessEnum.NonClinical;
        case LineOfBusiness.LocalLongTerm:
            return LineOfBusinessEnum.LocalLongTerm;
        case LineOfBusiness.Permanent:
            return LineOfBusinessEnum.Permanent;
        case LineOfBusiness.WorkforceDisruptionClinical:
            return LineOfBusinessEnum.WorkforceDisruptionClinical;
        case LineOfBusiness.WorkforceDisruptionNonClinical:
            return LineOfBusinessEnum.WorkforceDisruptionNonClinical;
        case LineOfBusiness.AccessControl:
            return LineOfBusinessEnum.AccessControl;
        case LineOfBusiness.InterimLeadership:
            return LineOfBusinessEnum.InterimLeadership;
        case LineOfBusiness.PayrollServices:
            return LineOfBusinessEnum.PayrollServices;
        default:
            return null;
    }
}
